"use client";

import React from "react";
import { Button } from "../../ui/button";

interface FinCstTailoringQuestionsProps {
  onBack?: () => void;
}

export default function FinCstTailoringQuestions({ onBack }: FinCstTailoringQuestionsProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white">Finance Cost - Tailoring Questions</h2>
          <p className="text-gray-400">No questions configured yet.</p>
        </div>
        {onBack && (
          <Button variant="outline" onClick={onBack}>Back</Button>
        )}
      </div>
    </div>
  );
}



